// extracted by mini-css-extract-plugin
module.exports = {"calendarItemHolder":"CalendarAssignPopup_calendarItemHolder__FEa1m","calendarItemHolderSelected":"CalendarAssignPopup_calendarItemHolderSelected__3phS8"};